import { render } from "./AppBackHistory.vue?vue&type=template&id=b236c716"
import script from "./AppBackHistory.vue?vue&type=script&lang=js"
export * from "./AppBackHistory.vue?vue&type=script&lang=js"

import exportComponent from "/home/admin/domains/web3.owatts.io/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__